import { partnerClient } from '@modules/core/services';
import { WithdrawalFormValues } from '../components/WithdrawalForm/WithdrawalForm.types';

const getPath = (): string => {
  return `/withdraw`;
};

export const submitWithdrawalForm = async (data: WithdrawalFormValues): Promise<any> => {
  const path = getPath();
  const response = await partnerClient.post(path, data);

  return response;
};
